import React from 'react';
import PropTypes from 'prop-types';

import {
  LabelWidget,
  NewRelicErrorChangeWidget,
} from '../../widgets';

import { Spinner } from '../../base';
import { Grid, Cell } from '../../base/styled';

const NewRelicIncidentByPolicy = (props) => {

  if (props.errorChangeData === undefined) {
    return (<Spinner />);
  }

  const {
    title = '',
    count = '',
    errorChangeData: {
      error: errorChangeError = null,
      data: errorChangeDataArray = [],
    } = {}
  } = props;

  let limit = 15;
  const widgetList = errorChangeDataArray.slice(0, limit).map((e, i) => (
    errorChangeError ? ({
      error: errorChangeError,
      data: null,
      key: `widget ${i}`,
    }) : ({
      data: e,
      key: `widget ${i}`,
    })));

  while (widgetList.length < 15) {
    widgetList.push({
      error: null,
      data: {
        title: '',
        count: ''
      },
    });
  }

  widgetList.forEach((e, i) => { e.key = i; });

  return (
    <div className="dashboard">
      <Grid columns={5} rows="75px 1fr 1fr 1fr" alignContent="stretch" height="inherit">
        <Cell width={5}>
          <LabelWidget input={{ data: { title, count } }} />
        </Cell>
        {
          widgetList.map(widget => (
            <Cell width={1} key={widget.key}>
              <NewRelicErrorChangeWidget input={widget} />
            </Cell>
          ))
        }
      </Grid>
    </div>
  );
};

NewRelicIncidentByPolicy.defaultProps = null;

NewRelicIncidentByPolicy.propTypes = {
  errorChangeData: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({ errorChangeWidgets: PropTypes.arrayOf(NewRelicErrorChangeWidget.dataPropType) }),
  })
};

export default NewRelicIncidentByPolicy;